/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import './ButtonRadio.scss';
import { appKeyCode, appRadioSize } from '@utils/globalConstant';
import PropTypes from 'prop-types';

export function ButtonRadio({
  isChecked = false,
  onChange,
  onClick,
  name = '',
  id = '',
  label = '',
  radioSize = appRadioSize.DEFAULT,
  valid = false,
  invalid = false,
  isDisabled = false,
  radioClass = '',
  ...restProps
}) {
  const [isFocused, setIsFocused] = useState(false);

  const handleKeyDown = (event) => {
    const { keyCode } = event;
    if (keyCode === appKeyCode.ENTER || keyCode === appKeyCode.SPACE) {
      event.preventDefault();
      onClick?.();
      onChange?.(true);
    }
  };

  const handleClick = () => {
    onClick?.();
    onChange?.(true); // For radio, set it to true when clicked.
  };

  return (
    <div
      className={`${radioClass} radio-wraper position-relative d-inline-flex align-items-center`}
      // tabIndex={isDisabled ? -1 : 0}
      onClick={() => !isDisabled && handleClick()}
      onFocus={() => !isDisabled && setIsFocused(true)}
      onBlur={() => !isDisabled && setIsFocused(false)}
      onKeyDown={(e) => !isDisabled && handleKeyDown(e)}>
      <div className="radio">
        <input
          // tabIndex={-1}
          className="radio position-absolute"
          id={id}
          name={name}
          checked={isChecked}
          onChange={() => onChange?.(true)}
          type="radio"
          disabled={isDisabled}
          {...{ ...restProps }}
        />
        <div
          className={`radio-icon 
            ${valid ? 'valid' : ''} 
            ${invalid ? 'invalid' : ''} 
            ${isFocused ? 'focused' : ''}`}
        />
      </div>
      {label && (
        <label 
          htmlFor={id}
          className={`${radioSize} text-primary ek-copy-16-regular radio-label ps-8`}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
    </div>
  );
}

ButtonRadio.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  radioSize: PropTypes.string,
  radioClass: PropTypes.string,
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  isDisabled: PropTypes.bool
};

export default ButtonRadio;
